module.exports = __webpack_public_path__ + "img/4-3.2c70f513.svg";